// AboutUs.jsx
import React, { useEffect, useState } from "react";
import "./CSS/AboutUs.css";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { useI18nField } from "../locale/LocaleContext";
import { useRouteMeta } from "./hooks/useRouteMeta";
import { marked } from "marked";

const AboutUs = () => {
  const f = useI18nField();
  const [aboutDoc, setAboutDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  // SEO tags
  useRouteMeta("AboutUs");

  // Fetch Firestore content
  useEffect(() => {
    async function load() {
      const ref = doc(db, "about-us", "about-us-description");
      const snap = await getDoc(ref);
      if (snap.exists()) setAboutDoc(snap.data());
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (!aboutDoc) return <div>No About Us content found.</div>;

  // Localized fields
  const title =
    f(aboutDoc, "title") ||
    f({ text: { en: "About Us", fr: "À propos de nous" } }, "text");

  const paragraph1 = f(aboutDoc, "paragraph1");
  const paragraph2 = f(aboutDoc, "paragraph2");
  const paragraph3 = f(aboutDoc, "paragraph3");

  // Combine paragraphs into markdown
  const markdown = [paragraph1, paragraph2, paragraph3]
    .filter(Boolean)
    .join("\n\n");

  return (
    <div className="about-us-container">
      <h1 className="about-us-title">{title}</h1>

      {/* Render markdown while KEEPING your styling */}
      <div
        className="about-us-content"
        dangerouslySetInnerHTML={{
          __html: marked.parse(markdown),
        }}
      />
    </div>
  );
};

export default AboutUs;
